// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Header — Soft UI Design System Pro navbar pattern
 * (floating "navbar-blur" card, soft shadows, gradient CTA), in BuzBiz gold.
 */
.header {
  --nav-text: #344767;
  --nav-text-strong: #141727;
  --nav-muted: #67748e;
  --nav-gold: #ffbc00;
  --nav-gold-deep: #e89a00;
  --nav-radius: 1rem;
  --nav-shadow: inset 0 0 1px 1px rgba(254, 254, 254, 0.9), 0 20px 27px 0 rgba(0, 0, 0, 0.05);
  --nav-dropdown-shadow: 0 8px 26px -4px rgba(20, 20, 20, 0.15), 0 8px 9px -5px rgba(20, 20, 20, 0.06);

  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;
  position: relative;
  z-index: 1000;
  width: 100%;
  height: 80px;
  padding-top: 8px;
  animation: fadeInDown 0.6s ease-out;
}

.header-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: auto;
  padding-top: 1rem;
}

.navbar {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: 0 0.75rem 0 1.25rem;
  border-radius: var(--nav-radius);
}

.navbar-blur {
  background-color: rgba(255, 255, 255, 0.8);
  -webkit-backdrop-filter: saturate(200%) blur(30px);
  backdrop-filter: saturate(200%) blur(30px);
  box-shadow: var(--nav-shadow);
}

.header-default .navbar-blur {
  box-shadow: var(--nav-shadow), 0 2px 12px 0 rgba(0, 0, 0, 0.08);
}

.logo {
  display: flex;
  align-items: center;
}

.logo-image {
  height: 40px;
  width: auto;
  object-fit: contain;
  transition: transform 0.2s ease;
}

.logo:hover .logo-image {
  transform: scale(1.03);
}

.nav-links {
  display: flex;
  gap: 0.25rem;
  align-items: center;
}

.nav-links > a,
.nav-links .dropdown-toggle {
  color: var(--nav-text);
  font-weight: 500;
  font-size: 0.875rem;
  padding: 0.5rem 0.875rem;
  border-radius: 0.5rem;
  transition: color 0.2s ease, background-color 0.2s ease;
}

.nav-links > a:hover,
.nav-links .dropdown-toggle:hover {
  color: var(--nav-text-strong);
  background-color: rgba(52, 71, 103, 0.06);
}

.nav-links a:focus-visible,
.get-started-btn:focus-visible,
.menu-toggle:focus-visible {
  outline: 2px solid var(--nav-gold-deep);
  outline-offset: 2px;
}

/* Dropdown */
.nav-dropdown {
  position: relative;
  z-index: 10001;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  cursor: pointer;
}

.dropdown-arrow {
  transition: transform 0.25s ease;
  color: var(--nav-muted);
}

.nav-dropdown:hover .dropdown-arrow,
.dropdown-arrow.active {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 0.75rem);
  left: 50%;
  min-width: 320px;
  padding: 0.5rem;
  background: #fff;
  border-radius: var(--nav-radius);
  box-shadow: var(--nav-dropdown-shadow);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform-origin: 50% 0;
  transform: translateX(-50%) perspective(999px) rotateX(-10deg) translateZ(0);
  transition: visibility 0.25s, opacity 0.25s, transform 0.25s;
  z-index: 10000;
}

/* Hover bridge so the menu stays open across the gap */
.dropdown-menu::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: -0.75rem;
  height: 0.75rem;
}

.dropdown-menu.active,
.nav-dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateX(-50%) perspective(999px) rotateX(0deg) translateZ(0);
}

a.dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.875rem;
  padding: 0.625rem 0.75rem;
  color: var(--nav-text);
  text-decoration: none;
  border-radius: 0.5rem;
  transition: background-color 0.2s ease;
}

a.dropdown-item:hover {
  background-color: #f8f9fa;
}

.dropdown-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.25rem;
  height: 2.25rem;
  font-size: 1.05rem;
  border-radius: 0.5rem;
  background: linear-gradient(310deg, #141727 0%, #3a416f 100%);
  color: #fff;
  box-shadow: 0 4px 7px -1px rgba(0, 0, 0, 0.11), 0 2px 4px -1px rgba(0, 0, 0, 0.07);
}

.dropdown-item-content {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.dropdown-item-title {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--nav-text-strong);
}

.dropdown-item-category {
  font-size: 0.75rem;
  color: var(--nav-muted);
}

.dropdown-badge {
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 0.2rem 0.45rem;
  border-radius: 0.375rem;
  color: #141727;
  background: linear-gradient(310deg, var(--nav-gold-deep) 0%, var(--nav-gold) 100%);
}

/* CTA — Soft UI gradient button */
.contact-info {
  display: flex;
  align-items: center;
}

.get-started-btn {
  display: inline-block;
  padding: 0.625rem 1.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  color: #141727;
  text-decoration: none;
  border-radius: 0.5rem;
  background-image: linear-gradient(310deg, var(--nav-gold-deep) 0%, var(--nav-gold) 100%);
  box-shadow: 0 4px 7px -1px rgba(0, 0, 0, 0.11), 0 2px 4px -1px rgba(0, 0, 0, 0.07);
  transition: transform 0.15s ease-in, box-shadow 0.15s ease-in;
}

.get-started-btn:hover {
  color: #141727;
  transform: scale(1.02);
  box-shadow: 0 7px 14px -1px rgba(0, 0, 0, 0.18), 0 2px 4px -1px rgba(0, 0, 0, 0.11);
}

.get-started-btn:active {
  transform: scale(1);
}

/* Mobile toggler — three bars that animate to an X */
.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  width: 40px;
  height: 40px;
  padding: 0 10px;
  background: none;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
}

.menu-toggle-bar {
  display: block;
  height: 2px;
  width: 100%;
  border-radius: 1px;
  background: var(--nav-text);
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.menu-toggle.open .menu-toggle-bar:nth-child(1) {
  transform: translateY(6px) rotate(45deg);
}

.menu-toggle.open .menu-toggle-bar:nth-child(2) {
  opacity: 0;
}

.menu-toggle.open .menu-toggle-bar:nth-child(3) {
  transform: translateY(-6px) rotate(-45deg);
}

@media (prefers-reduced-motion: reduce) {
  .header,
  .dropdown-menu,
  .menu-toggle-bar,
  .get-started-btn {
    animation: none;
    transition: none;
  }
}

@media (max-width: 768px) {
  .header-overlay {
    padding-top: 0.5rem;
  }

  .navbar {
    height: 60px;
    padding: 0 0.5rem 0 1rem;
  }

  .logo-image {
    height: 34px;
  }

  .menu-toggle {
    display: flex;
  }

  .contact-info {
    display: none;
  }

  /* The open menu is its own soft card under the bar */
  .nav-links {
    position: absolute;
    top: calc(100% + 0.5rem);
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    padding: 0.5rem;
    background: #fff;
    border-radius: var(--nav-radius);
    box-shadow: var(--nav-dropdown-shadow);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-8px);
    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    z-index: 9999;
  }

  .nav-links.active {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  .nav-links > a,
  .nav-links .dropdown-toggle {
    width: 100%;
    font-size: 0.95rem;
    padding: 0.875rem 0.75rem;
  }

  .nav-dropdown {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  a.dropdown-toggle {
    justify-content: space-between;
  }

  .dropdown-menu {
    position: static;
    min-width: auto;
    padding: 0;
    box-shadow: none;
    border-radius: 0.75rem;
    background: #f8f9fa;
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    transform: none !important;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease;
  }

  .dropdown-menu::before {
    display: none;
  }

  .dropdown-menu.active {
    max-height: 600px;
    padding: 0.375rem;
    margin-bottom: 0.25rem;
  }

  a.dropdown-item:hover {
    background-color: #fff;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,2FAA2F;EAC3F,oGAAoG;;EAEpG,sEAAsE;EACtE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,kDAAkD;EAClD,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;;EAEE,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;;;EAGE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sCAAsC;EACtC,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,4EAA4E;EAC5E,4DAA4D;EAC5D,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,6DAA6D;EAC7D,WAAW;EACX,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,kFAAkF;AACpF;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,wFAAwF;EACxF,kFAAkF;EAClF,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,mFAAmF;AACrF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;;;;IAIE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA,qDAAqD;EACrD;IACE,kBAAkB;IAClB,wBAAwB;IACxB,OAAO;IACP,QAAQ;IACR,sBAAsB;IACtB,oBAAoB;IACpB,MAAM;IACN,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,sCAAsC;IACtC,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAC3B,mEAAmE;IACnE,+BAA+B;IAC/B,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,oBAAoB;IACpB,0BAA0B;IAC1B,aAAa;IACb,gBAAgB;IAChB,mDAAmD;EACrD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/*\n * Header — Soft UI Design System Pro navbar pattern\n * (floating \"navbar-blur\" card, soft shadows, gradient CTA), in BuzBiz gold.\n */\n.header {\n  --nav-text: #344767;\n  --nav-text-strong: #141727;\n  --nav-muted: #67748e;\n  --nav-gold: #ffbc00;\n  --nav-gold-deep: #e89a00;\n  --nav-radius: 1rem;\n  --nav-shadow: inset 0 0 1px 1px rgba(254, 254, 254, 0.9), 0 20px 27px 0 rgba(0, 0, 0, 0.05);\n  --nav-dropdown-shadow: 0 8px 26px -4px rgba(20, 20, 20, 0.15), 0 8px 9px -5px rgba(20, 20, 20, 0.06);\n\n  font-family: 'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif;\n  position: relative;\n  z-index: 1000;\n  width: 100%;\n  height: 80px;\n  padding-top: 8px;\n  animation: fadeInDown 0.6s ease-out;\n}\n\n.header-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: auto;\n  padding-top: 1rem;\n}\n\n.navbar {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 64px;\n  padding: 0 0.75rem 0 1.25rem;\n  border-radius: var(--nav-radius);\n}\n\n.navbar-blur {\n  background-color: rgba(255, 255, 255, 0.8);\n  -webkit-backdrop-filter: saturate(200%) blur(30px);\n  backdrop-filter: saturate(200%) blur(30px);\n  box-shadow: var(--nav-shadow);\n}\n\n.header-default .navbar-blur {\n  box-shadow: var(--nav-shadow), 0 2px 12px 0 rgba(0, 0, 0, 0.08);\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n}\n\n.logo-image {\n  height: 40px;\n  width: auto;\n  object-fit: contain;\n  transition: transform 0.2s ease;\n}\n\n.logo:hover .logo-image {\n  transform: scale(1.03);\n}\n\n.nav-links {\n  display: flex;\n  gap: 0.25rem;\n  align-items: center;\n}\n\n.nav-links > a,\n.nav-links .dropdown-toggle {\n  color: var(--nav-text);\n  font-weight: 500;\n  font-size: 0.875rem;\n  padding: 0.5rem 0.875rem;\n  border-radius: 0.5rem;\n  transition: color 0.2s ease, background-color 0.2s ease;\n}\n\n.nav-links > a:hover,\n.nav-links .dropdown-toggle:hover {\n  color: var(--nav-text-strong);\n  background-color: rgba(52, 71, 103, 0.06);\n}\n\n.nav-links a:focus-visible,\n.get-started-btn:focus-visible,\n.menu-toggle:focus-visible {\n  outline: 2px solid var(--nav-gold-deep);\n  outline-offset: 2px;\n}\n\n/* Dropdown */\n.nav-dropdown {\n  position: relative;\n  z-index: 10001;\n}\n\n.dropdown-toggle {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  cursor: pointer;\n}\n\n.dropdown-arrow {\n  transition: transform 0.25s ease;\n  color: var(--nav-muted);\n}\n\n.nav-dropdown:hover .dropdown-arrow,\n.dropdown-arrow.active {\n  transform: rotate(180deg);\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: calc(100% + 0.75rem);\n  left: 50%;\n  min-width: 320px;\n  padding: 0.5rem;\n  background: #fff;\n  border-radius: var(--nav-radius);\n  box-shadow: var(--nav-dropdown-shadow);\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  transform-origin: 50% 0;\n  transform: translateX(-50%) perspective(999px) rotateX(-10deg) translateZ(0);\n  transition: visibility 0.25s, opacity 0.25s, transform 0.25s;\n  z-index: 10000;\n}\n\n/* Hover bridge so the menu stays open across the gap */\n.dropdown-menu::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: -0.75rem;\n  height: 0.75rem;\n}\n\n.dropdown-menu.active,\n.nav-dropdown:hover .dropdown-menu {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n  transform: translateX(-50%) perspective(999px) rotateX(0deg) translateZ(0);\n}\n\na.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 0.875rem;\n  padding: 0.625rem 0.75rem;\n  color: var(--nav-text);\n  text-decoration: none;\n  border-radius: 0.5rem;\n  transition: background-color 0.2s ease;\n}\n\na.dropdown-item:hover {\n  background-color: #f8f9fa;\n}\n\n.dropdown-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 2.25rem;\n  height: 2.25rem;\n  font-size: 1.05rem;\n  border-radius: 0.5rem;\n  background: linear-gradient(310deg, #141727 0%, #3a416f 100%);\n  color: #fff;\n  box-shadow: 0 4px 7px -1px rgba(0, 0, 0, 0.11), 0 2px 4px -1px rgba(0, 0, 0, 0.07);\n}\n\n.dropdown-item-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n}\n\n.dropdown-item-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: var(--nav-text-strong);\n}\n\n.dropdown-item-category {\n  font-size: 0.75rem;\n  color: var(--nav-muted);\n}\n\n.dropdown-badge {\n  font-size: 0.625rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 0.2rem 0.45rem;\n  border-radius: 0.375rem;\n  color: #141727;\n  background: linear-gradient(310deg, var(--nav-gold-deep) 0%, var(--nav-gold) 100%);\n}\n\n/* CTA — Soft UI gradient button */\n.contact-info {\n  display: flex;\n  align-items: center;\n}\n\n.get-started-btn {\n  display: inline-block;\n  padding: 0.625rem 1.5rem;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  color: #141727;\n  text-decoration: none;\n  border-radius: 0.5rem;\n  background-image: linear-gradient(310deg, var(--nav-gold-deep) 0%, var(--nav-gold) 100%);\n  box-shadow: 0 4px 7px -1px rgba(0, 0, 0, 0.11), 0 2px 4px -1px rgba(0, 0, 0, 0.07);\n  transition: transform 0.15s ease-in, box-shadow 0.15s ease-in;\n}\n\n.get-started-btn:hover {\n  color: #141727;\n  transform: scale(1.02);\n  box-shadow: 0 7px 14px -1px rgba(0, 0, 0, 0.18), 0 2px 4px -1px rgba(0, 0, 0, 0.11);\n}\n\n.get-started-btn:active {\n  transform: scale(1);\n}\n\n/* Mobile toggler — three bars that animate to an X */\n.menu-toggle {\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  gap: 4px;\n  width: 40px;\n  height: 40px;\n  padding: 0 10px;\n  background: none;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n}\n\n.menu-toggle-bar {\n  display: block;\n  height: 2px;\n  width: 100%;\n  border-radius: 1px;\n  background: var(--nav-text);\n  transition: transform 0.2s ease, opacity 0.2s ease;\n}\n\n.menu-toggle.open .menu-toggle-bar:nth-child(1) {\n  transform: translateY(6px) rotate(45deg);\n}\n\n.menu-toggle.open .menu-toggle-bar:nth-child(2) {\n  opacity: 0;\n}\n\n.menu-toggle.open .menu-toggle-bar:nth-child(3) {\n  transform: translateY(-6px) rotate(-45deg);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .header,\n  .dropdown-menu,\n  .menu-toggle-bar,\n  .get-started-btn {\n    animation: none;\n    transition: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .header-overlay {\n    padding-top: 0.5rem;\n  }\n\n  .navbar {\n    height: 60px;\n    padding: 0 0.5rem 0 1rem;\n  }\n\n  .logo-image {\n    height: 34px;\n  }\n\n  .menu-toggle {\n    display: flex;\n  }\n\n  .contact-info {\n    display: none;\n  }\n\n  /* The open menu is its own soft card under the bar */\n  .nav-links {\n    position: absolute;\n    top: calc(100% + 0.5rem);\n    left: 0;\n    right: 0;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0;\n    padding: 0.5rem;\n    background: #fff;\n    border-radius: var(--nav-radius);\n    box-shadow: var(--nav-dropdown-shadow);\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-8px);\n    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;\n    max-height: calc(100vh - 100px);\n    overflow-y: auto;\n    z-index: 9999;\n  }\n\n  .nav-links.active {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n  }\n\n  .nav-links > a,\n  .nav-links .dropdown-toggle {\n    width: 100%;\n    font-size: 0.95rem;\n    padding: 0.875rem 0.75rem;\n  }\n\n  .nav-dropdown {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  a.dropdown-toggle {\n    justify-content: space-between;\n  }\n\n  .dropdown-menu {\n    position: static;\n    min-width: auto;\n    padding: 0;\n    box-shadow: none;\n    border-radius: 0.75rem;\n    background: #f8f9fa;\n    opacity: 1;\n    visibility: visible;\n    pointer-events: auto;\n    transform: none !important;\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.3s ease, padding 0.3s ease;\n  }\n\n  .dropdown-menu::before {\n    display: none;\n  }\n\n  .dropdown-menu.active {\n    max-height: 600px;\n    padding: 0.375rem;\n    margin-bottom: 0.25rem;\n  }\n\n  a.dropdown-item:hover {\n    background-color: #fff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
